"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ButtonGroup_1 = __importDefault(require("../ButtonGroup"));
var Button_1 = __importDefault(require("../Button"));
var Menu_1 = __importDefault(require("../Menu"));
var prism_icons_1 = require("@octanner/prism-icons");
var DualActionButton = function (_a) {
    var children = _a.children, label = _a.label, onClick = _a.onClick, adminColor = _a.adminColor, menuProps = _a.menuProps, props = __rest(_a, ["children", "label", "onClick", "adminColor", "menuProps"]);
    var _b = __read(react_1.default.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var mappedChildren = react_1.default.Children.map(children, function (child) {
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, {
                // TODO figure out a way to remove this ts-ignore
                // @ts-ignore this is an HTMLElement and does have onClick prop available
                onClick: function (e) {
                    setAnchorEl(null);
                    if (child.props.onClick) {
                        child.props.onClick(e);
                    }
                },
            });
        }
    });
    var maxHeight = (menuProps === null || menuProps === void 0 ? void 0 : menuProps.maxHeight) || 'None';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ButtonGroup_1.default, __assign({}, props),
            react_1.default.createElement(Button_1.default, { onClick: onClick, adminColor: adminColor, sx: {
                    borderRadius: '5px',
                } }, label),
            react_1.default.createElement(Button_1.default, { onClick: function (e) { return setAnchorEl(e.currentTarget); }, adminColor: adminColor },
                react_1.default.createElement(prism_icons_1.ArrowTriangleDown, null))),
        react_1.default.createElement(Menu_1.default, { PaperProps: {
                sx: {
                    maxHeight: maxHeight,
                },
            }, MenuListProps: {
                sx: {
                    maxHeight: maxHeight,
                    overflowY: 'auto',
                },
            }, open: !!anchorEl, anchorEl: anchorEl, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, transformOrigin: { horizontal: 'right', vertical: 'top' }, onClose: function () { return setAnchorEl(null); } }, mappedChildren)));
};
exports.default = DualActionButton;
//# sourceMappingURL=index.js.map